function getPictureAccent(selectedBy, activeClient, isAggregate, fallbackColor) {
  if (isAggregate) return selectedBy[0]?.color || fallbackColor;
  return selectedBy.find(client => client.id === activeClient)?.color || fallbackColor;
}

export { getPictureAccent };
